import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import Logo from '../../assets/perseghian/logo.png';
import { LinkMenu } from './styles';

export default function Menu() {
  const [fixedMenu, setFixedMenu] = useState('');
  const [expanded, setExpanded] = useState(false);
  
  const handleScroll = () => {
    const position = window.pageYOffset;
    if(position > 50)
     setFixedMenu('sticky-top') 
    else
     setFixedMenu('');
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  return(
    <div className={`${fixedMenu}`}>
      <Navbar expand="lg" expanded={expanded} className={`clearfix no-padding nav-color`}>
        <Container>
          <div className="logo-style float-left">
            <a href="https://parseghianfund.nd.edu" rel="noreferrer" target="_blank">
              <img src={Logo} alt="ara perseghian medical research fund logo" className="img-fluid" width="200px"/>
            </a>
          </div>
          <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setExpanded(!expanded)} className={`nav-button-collapsed`}/>
          <Navbar.Collapse id="basic-navbar-nav" >
          <Nav className="me-auto">
            <LinkMenu onClick={() => setExpanded(false)} to="home" className="text-lg-center">Home </LinkMenu>
            <LinkMenu onClick={() => setExpanded(false)} to="leaderboard" className="text-lg-center">Leaderboard</LinkMenu>
            <LinkMenu onClick={() => setExpanded(false)} to="scoreboards" className="text-lg-center">Scorecards</LinkMenu>
            <LinkMenu onClick={() => setExpanded(false)} to="holedashboard" className="text-lg-center">Hole by Hole</LinkMenu>
            <LinkMenu onClick={() => setExpanded(false)} to="geography" className="text-lg-center">Geography</LinkMenu>
            <LinkMenu onClick={() => setExpanded(false)} to="bonus-games" className="text-lg-center">Bonus Games</LinkMenu>
            <LinkMenu onClick={() => setExpanded(false)} to="about" className="text-lg-center">About IPC</LinkMenu>
          </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  )
}